import * as React from 'react';

export interface WithVisibilityProps {
    isVisible: boolean;
    isHidden: boolean;
}

const isPageVisSupported =
    window.document && typeof window.document.visibilityState !== 'undefined';

const getVisibilityStatus = (visibilityState: string) => ({
    isVisible: visibilityState === 'visible',
    isHidden: visibilityState === 'hidden',
});

export const withVisibility = (WrappedComponent: any) => {
    if (!isPageVisSupported) return WrappedComponent;

    return class extends React.Component {
        constructor(props: any) {
            super(props);

            this.state = getVisibilityStatus(window.document.visibilityState);
            this.onVisibilityChange = this.onVisibilityChange.bind(this);
        }

        componentDidMount() {
            window.document.addEventListener('visibilitychange', this.onVisibilityChange, false);
        }

        componentWillUnmount() {
            window.document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }

        onVisibilityChange() {
            this.setState(getVisibilityStatus(window.document.visibilityState));
        }

        render() {
            if (!isPageVisSupported) {
                return <WrappedComponent />;
            }

            return <WrappedComponent {...this.state} {...this.props} />;
        }
    };
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/HOC/withVisibility.tsx